import { ConfigurationItem } from "constants/configurations";
import { getSelectedConfigurationTabFromStorage } from "shared/storageUtils";
import {
  type ConfigurationDispatchAction,
  SET_SELECTED_CONFIGURATION_TAB,
} from "../actions/configurationActions";

export type ConfigurationState = {
  selectedTab: ConfigurationItem;
};

const storageValue =
  getSelectedConfigurationTabFromStorage() as ConfigurationItem | null;
const parsedStorageValue =
  storageValue != null ? (Number(storageValue) as ConfigurationItem) : null;

export const initialState: ConfigurationState = {
  selectedTab: parsedStorageValue ?? ConfigurationItem.ANIMAL_CATEGORY,
};

export default function configurationReducer(
  state: ConfigurationState = initialState,
  action: ConfigurationDispatchAction
): ConfigurationState {
  if (action.type === SET_SELECTED_CONFIGURATION_TAB) {
    return {
      ...state,
      selectedTab: action.payload.tab,
    };
  }

  return { ...state };
}
